import { all, fork } from "redux-saga/effects"

//public
import LayoutSaga from "./layout/saga"
import authSaga from "./auth/login/saga.js"
import ProfileSaga from "./auth/profile/saga"
import Auth from "./auth/validate/saga";

export default function* rootSaga() {
  yield all([
    LayoutSaga(),
    fork(authSaga),
    ProfileSaga(),
    fork(Auth),
  ])
}
